"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class DeviceApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * for CA-989 https://dimorder.atlassian.net/browse/CA-989
     * CA 的 findOfflineDevice 會抓 master device 判斷 device.lastHealthTime 確認 master 是否在線上
     * 但該功能目前此功能備註解掉，未被使用
     */
    getMerchantDevices(merchantId, isMaster) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/device';
            const params = {
                merchantID: merchantId,
                master: isMaster,
            };
            const resposne = yield this.api.axiosGo.get(endpoint, { params });
            return resposne.data;
        });
    }
}
exports.default = DeviceApi;
//# sourceMappingURL=Device.js.map